// Mock Data for Neurology Category

const baseProducts = [
    {
        id: "med-neuro-1",
        name: "Levetiracetam 1000mg",
        genericName: "Brand: Keppra",
        indication: "Epilepsy",
        price: "$42",
        originalPrice: "$500",
        savings: "92%",
        description: "An anticonvulsant medication used in combination with other medications to treat certain types of seizures in people with epilepsy.",
        dosage: "Typically taken twice a day, with or without food. Follow your neurologist's instructions.",
        packaging: "Contains 60 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from light and moisture.",
        sideEffects: "Drowsiness, weakness, infection, or loss of appetite. Report mood changes immediately.",
        category: "Anticonvulsants"
    },
    {
        id: "med-neuro-2",
        name: "Levodopa/Carbidopa",
        genericName: "Brand: Sinemet",
        indication: "Parkinson's Disease",
        price: "$30",
        originalPrice: "$420",
        savings: "93%",
        description: "A combination medication used to treat symptoms of Parkinson's disease, such as shakiness, stiffness, and difficulty moving. Levodopa changes into dopamine in the brain.",
        dosage: "Taken multiple times a day as prescribed. Take with food to reduce nausea.",
        packaging: "Contains 100 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature below 30°C in a dry place.",
        sideEffects: "Nausea, dizziness, or uncontrolled movements (dyskinesia).",
        category: "Anti-Parkinson Agents"
    },
    {
        id: "med-neuro-3",
        name: "Glatiramer 40mg",
        genericName: "Brand: Copaxone (Biosimilar)",
        indication: "Multiple Sclerosis",
        price: "$480",
        originalPrice: "$6,000",
        savings: "92%",
        description: "Used to treat relapsing forms of multiple sclerosis (MS). It helps prevent MS relapses and may slow the accumulation of physical disability.",
        dosage: "Administered as a subcutaneous injection three times a week.",
        packaging: "Contains 12 Pre-filled Syringes (1-month supply)",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store refrigerated between 2°C and 8°C. Do not freeze.",
        sideEffects: "Injection site reactions, flushing, shortness of breath, or rash.",
        category: "Disease-Modifying Therapies (MS)"
    },
    {
        id: "med-neuro-4",
        name: "Fingolimod 0.5mg",
        genericName: "Brand: Gilenya",
        indication: "Multiple Sclerosis",
        price: "$595",
        originalPrice: "$8,500",
        savings: "93%",
        description: "An immunosuppressant used to treat relapsing multiple sclerosis. It prevents immune cells from reaching the central nervous system to reduce inflammation.",
        dosage: "Taken orally once daily, with or without food.",
        packaging: "Contains 28 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from moisture and heat.",
        sideEffects: "Headache, diarrhea, back pain, or liver enzyme elevation. Requires monitoring.",
        category: "Disease-Modifying Therapies (MS)"
    },
    {
        id: "med-neuro-5",
        name: "Pregabalin 300mg",
        genericName: "Brand: Lyrica",
        indication: "Neuropathic Pain/Epilepsy",
        price: "$55",
        originalPrice: "$520",
        savings: "89%",
        description: "Used to treat pain caused by nerve damage due to diabetes, shingles (herpes zoster) infection, or spinal cord injury. Also used in combination to treat partial onset seizures.",
        dosage: "Usually taken 2 or 3 times a day as prescribed by your doctor.",
        packaging: "Contains 60 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at 25°C; excursions permitted to 15-30°C.",
        sideEffects: "Dizziness, somnolence, dry mouth, edema, or blurred vision.",
        category: "Neuropathic Pain / Anticonvulsants"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-neuro-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Neurological Disorders and Condition Management",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of complex neurological conditions. Sourced from WHO-GMP certified facilities ensuring efficacy and safety.`,
            dosage: "As prescribed by your neurologist.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. Regular monitoring may be required.",
            category: "General Neurological Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const neurologyProducts = [...baseProducts, ...generateAlphabetMeds()];

export const neurologyHeroData = {
    title: "Neurological Disorders",
    subtitle: "Epilepsy, Parkinson's, MS, and neurological condition management",
    description: "Access high-quality, authentic medications for the management of Epilepsy, Parkinson's Disease, Multiple Sclerosis, and other complex neurological conditions. Our global network connects you to affordable generics and biosimilars securely.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "90%", label: "Average Savings" }
    ]
};

export const neurologyCategories = [
    "All Categories",
    "Anticonvulsants",
    "Anti-Parkinson Agents",
    "Disease-Modifying Therapies (MS)",
    "Neuropathic Pain",
    "General Neurological Care"
];

export const neurologyTrustBadges = [
    { text: "WHO-GMP Certified Sources", icon: "ShieldCheck" },
    { text: "Secure Global Shipping", icon: "Plane" },
    { text: "Specialized Care", icon: "Brain" },
    { text: "Authenticity Guaranteed", icon: "Award" }
];

export const neurologyFAQs = [
    {
        question: "Do you require a prescription for neurology medications?",
        answer: "Yes. All neurology medications, including anticonvulsants and MS therapies, require a valid prescription from a licensed neurologist or physician to ensure safe and appropriate use."
    },
    {
        question: "How do you handle shipping for temperature-sensitive MS medications?",
        answer: "Medications like Glatiramer that require refrigeration are shipped using validated cold-chain logistics, complete with temperature loggers to ensure they remain between 2°C and 8°C throughout transit."
    },
    {
        question: "Are generic neurology medications as effective as the brand-name versions?",
        answer: "Yes. The generics and biosimilars we supply are rigorously tested for bioequivalence, meaning they deliver the same active ingredients, at the same rate and extent, as the costly brand-name drugs."
    },
    {
        question: "Can I coordinate bulk orders for chronic condition management?",
        answer: "Absolutely. We specialize in providing reliable, long-term supplies (e.g., 3-6 months) for chronic neurological conditions, ensuring continuity of care without interruption."
    }
];

export const neurologyTestimonials = [
    {
        name: "Robert E.",
        country: "United States",
        savings: "$90,000 annually",
        condition: "Multiple Sclerosis",
        medication: "Fingolimod (Gilenya Generic)",
        text: "The cost of Gilenya was devastating. Sourcing the generic form through MediSeller has given me my life and financial stability back. The medication works exactly the same."
    },
    {
        name: "Claire M.",
        country: "Australia",
        savings: "$4,500 annually",
        condition: "Parkinson's Disease",
        medication: "Levodopa/Carbidopa",
        text: "Managing Parkinson's is stressful enough without worrying about prescription costs. MediSeller provides consistent, high-quality generics that keep my symptoms controlled at a fraction of the cost."
    },
    {
        name: "Thomas B.",
        country: "United Kingdom",
        savings: "$5,000 annually",
        condition: "Epilepsy",
        medication: "Levetiracetam",
        text: "I was skeptical about switching to generics internationally, but the quality has been perfect. I haven't had a single seizure since starting, and the customer service during international shipping is excellent."
    }
];

export const neurologySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Learn how patients are successfully managing chronic neurological conditions through secure, affordable treatment."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important information about ordering specialty neurology medications safely."
    },
    midPageCTA: {
        title: "Looking for a Specific Neurology Treatment?",
        description: "Our procurement specialists can source a wide range of anti-epileptic drugs, MS therapies, and Parkinson's medications globally at up to 90% savings.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Sourcing Assistance"
    },
    finalCTA: {
        title: "Manage Your Condition with Confidence",
        description: "Don't let the high cost of neurology medications prevent you from living fully. Secure your continuous treatment today.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
